module.exports = __webpack_public_path__ + "img/step5_Kernaufgaben.6435e6bb.png";